import { render } from "./ModalImportExcel.vue?vue&type=template&id=6ca06531&scoped=true"
import script from "./ModalImportExcel.vue?vue&type=script&lang=js"
export * from "./ModalImportExcel.vue?vue&type=script&lang=js"

import "./ModalImportExcel.vue?vue&type=style&index=0&id=6ca06531&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca06531"]])

export default __exports__